import React from "react";
import {IonFab, IonFabButton, IonIcon} from "@ionic/react";
import {closeOutline} from "ionicons/icons";

/**
 * Component displaying a red button with a white cross.
 * @author Alizée Grand
 * @version 1.1
 * @creation 29/04/2021
 * @last_update 05/01/2022
 **/
class CloseButton extends React.Component<{
    onClickAction: () => void,
}> {
    render() {
        return (
            <IonFab vertical="top" horizontal="end">
                <IonFabButton size="small" onClick={this.props.onClickAction} color="danger">
                    <IonIcon icon={closeOutline} />
                </IonFabButton>
            </IonFab>
        );
    }
}

export default CloseButton;
